const pcnList = pcns => ((!pcns || pcns.length < 2)
  ? ''
  : `
  <select class="form-control inline-select selectpicker" id="pcnList" data-width="auto" title="Select a PCN">
  ${pcns.sort((a, b) => {
    if (a.name > b.name) return 1;
    if (a.name === b.name) return 0;
    return -1;
  }).map(pcn => `
      <option value="${pcn._id}" ${pcn.isSelected ? 'selected' : ''}>${pcn.name}</option>`).join('')}
  </select>
`);

const indicatorList = indicators => `
<div class="form-group">
  <select class="form-control inline-select selectpicker" id="indicatorList" data-live-search="true" data-width="auto">
    <option value="0">All Indicators</option>
  ${indicators.sort((a, b) => {
    if (a.short_name > b.short_name) return 1;
    if (a.short_name === b.short_name) return 0;
    return -1;
  }).map(indicator => `
      <option value="${indicator._id}" ${indicator.isSelected ? 'selected' : ''}>${indicator.short_name}</option>`).join('')}
  </select>
</div>
`;

const dateList = (dates, id, name, title) => `
<div class="form-group left-buffer align-bottom">
  <label for="${name}" style="display:block;">${title}:</label>
  <select class="inline-select" id="${id}" name="${name}">
    ${dates
    .filter(date => date.shouldDisplay)
    .map(date => `
      <option value="${date._id}" ${date.isSelected ? 'selected' : ''}>${date.value}</option>
    `).join('')}
  </select>
</div>
`;

export default (pcns, indicators, dates, comparisonDates, displayComparisonDate) => `
<form id="filterBarPcn" class="form-inline">  
  <div class="form-group">
  ${pcns && pcns.length === 1
    ? `<h2>${pcns[0].name}</h2>`
    : pcnList(pcns)}
  </div>
  ${indicatorList(indicators)}
  ${dateList(dates, 'dateList', 'reportDate', 'Report date')}
  ${displayComparisonDate ? dateList(comparisonDates, 'dateCompareList', 'comparisonDate', 'Comparison date') : ""}
</form>
  `;
